import { Component, Injector, Input, ViewChild } from '@angular/core';
import { delay, filter, map, Observable } from 'rxjs';
import { COMPLEX_DIALOG_INPUT_DATA } from './complex-dialog-v2.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as i0 from "@angular/core";
import * as i1 from "./embedded-view/complex-dialog-embedded-view.service";
import * as i2 from "@angular/common";
import * as i3 from "../button-v2/button.component";
import * as i4 from "primeng/api";
import * as i5 from "primeng/confirmdialog";
import * as i6 from "../icon-v2/icon.component";
import * as i7 from "@ngx-translate/core";
/**
 * @deprecated use complex dialog v3 component instead
 */
const _c0 = ["dialogContentComponent"];
const _c1 = ["dialog"];
function ComplexDialogV2Component_ng_template_3_div_0_geaui_icon_v2_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-icon-v2", 11);
    i0.ɵɵlistener("click", function ComplexDialogV2Component_ng_template_3_div_0_geaui_icon_v2_4_Template_geaui_icon_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onNoClick());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("clickable", true)("color", "black")("file", ctx_r1.closeIcon);
  }
}
function ComplexDialogV2Component_ng_template_3_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "span", 9);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ComplexDialogV2Component_ng_template_3_div_0_geaui_icon_v2_4_Template, 1, 3, "geaui-icon-v2", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, ctx_r1.title));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.closable);
  }
}
function ComplexDialogV2Component_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ComplexDialogV2Component_ng_template_3_div_0_Template, 5, 4, "div", 7);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r1.hideHeader);
  }
}
function ComplexDialogV2Component_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 12, 1);
  }
}
function ComplexDialogV2Component_ng_template_5_div_0_geaui_button_v2_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-button-v2", 16);
    i0.ɵɵlistener("click", function ComplexDialogV2Component_ng_template_5_div_0_geaui_button_v2_1_Template_geaui_button_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onNoClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("type", "secondary");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, ctx_r1.no), " ");
  }
}
function ComplexDialogV2Component_ng_template_5_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ComplexDialogV2Component_ng_template_5_div_0_geaui_button_v2_1_Template, 3, 4, "geaui-button-v2", 14);
    i0.ɵɵelementStart(2, "geaui-button-v2", 15);
    i0.ɵɵlistener("click", function ComplexDialogV2Component_ng_template_5_div_0_Template_geaui_button_v2_click_2_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onYesClick());
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_6_0;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showRejectButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", "primary")("sending", ctx_r1.loading)("disabled", (tmp_6_0 = ctx_r1.componentContentRef == null ? null : ctx_r1.componentContentRef.instance == null ? null : ctx_r1.componentContentRef.instance.isAcceptDisabled) !== null && tmp_6_0 !== undefined ? tmp_6_0 : ctx_r1.initialAcceptDisabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 5, ctx_r1.yes), " ");
  }
}
function ComplexDialogV2Component_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ComplexDialogV2Component_ng_template_5_div_0_Template, 5, 7, "div", 13);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r1.hideButtons);
  }
}
export class ComplexDialogV2Component {
  complexDialogEmbeddedViewService;
  vcRef;
  renderer;
  injector;
  destroyed;
  no = '';
  yes = '';
  hideButtons = false;
  hideDividingLines = false;
  hideHeader = false;
  initialAcceptDisabled = false;
  title = '';
  closable = true;
  confirmCallback;
  rejectCallback;
  visible = false;
  showRejectButton = false;
  loading = false;
  componentContentRef = null;
  key = 'complex-dialog';
  dialogContentComponent;
  dialog;
  closeIcon = '16px_close';
  inputData;
  outputData;
  constructor(complexDialogEmbeddedViewService, vcRef, renderer, injector, destroyed) {
    this.complexDialogEmbeddedViewService = complexDialogEmbeddedViewService;
    this.vcRef = vcRef;
    this.renderer = renderer;
    this.injector = injector;
    this.destroyed = destroyed;
  }
  ngOnInit() {
    this.listenForInitializeDialogData();
    this.listenForRenderingComponentTemplate();
    this.listenForDataOutputTriggering();
  }
  ngOnDestroy() {
    this.componentContentRef?.destroy();
  }
  onNoClick() {
    this.componentContentRef?.instance?.onRejectClick?.();
    if (!this.rejectCallback) {
      this.dialog.reject();
      return;
    }
    const result = this.rejectCallback();
    if (!(result instanceof Observable)) {
      this.dialog.reject();
      return;
    }
    this.loading = true;
    result.subscribe({
      next: () => {
        this.dialog.reject();
        this.loading = false;
      },
      error: () => this.loading = false
    });
  }
  onYesClick() {
    this.componentContentRef?.instance?.onAcceptClick?.();
    if (!this.confirmCallback) {
      this.dialog.accept();
      return;
    }
    const result = this.confirmCallback(this.outputData);
    if (!(result instanceof Observable)) {
      this.dialog.accept();
      return;
    }
    this.loading = true;
    result.subscribe({
      next: () => {
        this.dialog.accept();
        this.loading = false;
      },
      error: () => this.loading = false
    });
  }
  createInputInjection() {
    return Injector.create({
      providers: [{
        provide: COMPLEX_DIALOG_INPUT_DATA,
        useValue: this.inputData
      }],
      parent: this.injector
    });
  }
  listenForRenderingComponentTemplate() {
    this.complexDialogEmbeddedViewService.componentTyeData.pipe(filter(componentTyeData => this.isCorrectDialog(componentTyeData.key)), map(componentTyeData => componentTyeData.componentType), takeUntilDestroyed(this.destroyed), delay(10)).subscribe(componentType => this.renderEmbeddedView(componentType));
  }
  initButtons(data) {
    const {
      no,
      yes,
      hideButtons,
      closable,
      showRejectButton
    } = data;
    this.closable = closable ?? true;
    this.hideButtons = !!hideButtons;
    this.showRejectButton = showRejectButton ?? true;
    this.yes = yes ?? '';
    this.no = no ?? '';
    this.initialAcceptDisabled = !!data.initialAcceptDisabled;
  }
  listenForInitializeDialogData() {
    this.complexDialogEmbeddedViewService.dialogData$.pipe(takeUntilDestroyed(this.destroyed), filter(complexDialogV2Config => this.isCorrectDialog(complexDialogV2Config.key)), map(complexDialogV2Config => complexDialogV2Config.data)).subscribe(complexDialogV2Config => {
      this.title = complexDialogV2Config.title ?? '';
      this.initButtons(complexDialogV2Config);
      this.confirmCallback = complexDialogV2Config.confirmCallback;
      this.rejectCallback = complexDialogV2Config.rejectCallback;
      this.inputData = complexDialogV2Config.data;
      this.hideDividingLines = complexDialogV2Config.hideDividingLines ?? false;
      this.hideHeader = !!complexDialogV2Config.hideHeader;
    });
  }
  listenForDataOutputTriggering() {
    this.complexDialogEmbeddedViewService.dataOutputForComponent$.pipe(takeUntilDestroyed(this.destroyed)).subscribe(data => {
      this.outputData = data;
    });
  }
  isCorrectDialog(key) {
    return key === this.key;
  }
  renderEmbeddedView(componentType) {
    if (this.componentContentRef) {
      // if embedded View is already rendered, remove the old view, to fix the issue of multiple view rendering
      this.renderer.removeChild(this.dialogContentComponent.nativeElement, this.componentContentRef.location.nativeElement);
    }
    this.componentContentRef = this.vcRef.createComponent(componentType, {
      injector: this.createInputInjection()
    });
    this.renderer.appendChild(this.dialogContentComponent.nativeElement, this.componentContentRef.location.nativeElement);
  }
  static ɵfac = function ComplexDialogV2Component_Factory(t) {
    return new (t || ComplexDialogV2Component)(i0.ɵɵdirectiveInject(i1.ComplexDialogEmbeddedViewService), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.DestroyRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ComplexDialogV2Component,
    selectors: [["geaui-complex-dialog-v2"]],
    viewQuery: function ComplexDialogV2Component_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dialogContentComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dialog = _t.first);
      }
    },
    inputs: {
      key: "key"
    },
    decls: 6,
    vars: 10,
    consts: [["dialog", ""], ["dialogContentComponent", ""], [1, "complex-dialog-container"], [3, "key", "focusTrap"], ["pTemplate", "header"], ["pTemplate", "message"], ["pTemplate", "footer"], ["class", "complex-dialog-header-content", 4, "ngIf"], [1, "complex-dialog-header-content"], [1, "complex-dialog-title", "gea-font-heading-24"], ["class", "complex-dialog-close-icon", 3, "clickable", "color", "file", "click", 4, "ngIf"], [1, "complex-dialog-close-icon", 3, "click", "clickable", "color", "file"], [1, "dialog-content"], [4, "ngIf"], ["class", "gea-dialog-btn", 3, "type", "click", 4, "ngIf"], [1, "gea-dialog-btn", 3, "click", "type", "sending", "disabled"], [1, "gea-dialog-btn", 3, "click", "type"]],
    template: function ComplexDialogV2Component_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "section", 2)(1, "p-confirmDialog", 3, 0);
        i0.ɵɵtemplate(3, ComplexDialogV2Component_ng_template_3_Template, 1, 1, "ng-template", 4)(4, ComplexDialogV2Component_ng_template_4_Template, 2, 0, "ng-template", 5)(5, ComplexDialogV2Component_ng_template_5_Template, 1, 1, "ng-template", 6);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵclassProp("no-border-top-footer", ctx.hideButtons)("no-borders", ctx.hideDividingLines)("no-header", ctx.hideHeader);
        i0.ɵɵadvance();
        i0.ɵɵclassProp("no-title", ctx.title.length === 0);
        i0.ɵɵproperty("key", ctx.key)("focusTrap", false);
      }
    },
    dependencies: [i2.NgIf, i3.ButtonV2Component, i4.PrimeTemplate, i5.ConfirmDialog, i6.IconComponent, i7.TranslatePipe],
    styles: [".complex-dialog-header-content[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;width:100%;height:72px}.dialog-content[_ngcontent-%COMP%]{height:100%;width:100%;overflow:hidden}.complex-dialog-close-icon[_ngcontent-%COMP%]{display:block;cursor:pointer}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ComplexDialogV2Component, [{
    type: Component,
    args: [{
      selector: 'geaui-complex-dialog-v2',
      template: "<section\n  class=\"complex-dialog-container\"\n  [class.no-border-top-footer]=\"hideButtons\"\n  [class.no-borders]=\"hideDividingLines\"\n  [class.no-header]=\"hideHeader\">\n  <p-confirmDialog #dialog [key]=\"key\" [focusTrap]=\"false\" [class.no-title]=\"title.length === 0\">\n    <ng-template pTemplate=\"header\">\n      <div class=\"complex-dialog-header-content\" *ngIf=\"!hideHeader\">\n        <span class=\"complex-dialog-title gea-font-heading-24\">{{ title | translate }}</span>\n        <geaui-icon-v2\n          class=\"complex-dialog-close-icon\"\n          *ngIf=\"closable\"\n          [clickable]=\"true\"\n          [color]=\"'black'\"\n          [file]=\"closeIcon\"\n          (click)=\"onNoClick()\">\n        </geaui-icon-v2>\n      </div>\n    </ng-template>\n    <ng-template pTemplate=\"message\" let-message>\n      <div class=\"dialog-content\" #dialogContentComponent></div>\n    </ng-template>\n    <ng-template pTemplate=\"footer\">\n      <div *ngIf=\"!hideButtons\">\n        <geaui-button-v2 class=\"gea-dialog-btn\" *ngIf=\"showRejectButton\" [type]=\"'secondary'\" (click)=\"onNoClick()\">\n          {{ no | translate }}\n        </geaui-button-v2>\n        <geaui-button-v2\n          class=\"gea-dialog-btn\"\n          [type]=\"'primary'\"\n          [sending]=\"loading\"\n          [disabled]=\"componentContentRef?.instance?.isAcceptDisabled ?? initialAcceptDisabled\"\n          (click)=\"onYesClick()\">\n          {{ yes | translate }}\n        </geaui-button-v2>\n      </div>\n    </ng-template>\n  </p-confirmDialog>\n</section>\n",
      styles: [".complex-dialog-header-content{display:flex;justify-content:space-between;align-items:center;width:100%;height:72px}.dialog-content{height:100%;width:100%;overflow:hidden}.complex-dialog-close-icon{display:block;cursor:pointer}\n"]
    }]
  }], () => [{
    type: i1.ComplexDialogEmbeddedViewService
  }, {
    type: i0.ViewContainerRef
  }, {
    type: i0.Renderer2
  }, {
    type: i0.Injector
  }, {
    type: i0.DestroyRef
  }], {
    key: [{
      type: Input
    }],
    dialogContentComponent: [{
      type: ViewChild,
      args: ['dialogContentComponent']
    }],
    dialog: [{
      type: ViewChild,
      args: ['dialog']
    }]
  });
})();
